document.addEventListener('turbolinks:load', function () {
    if ($('.master-violation-form-modal').length === 0) {
        return false
    }

    $(document).on('change', '#ce_master_violation_handled_by', function () {
        let handledBy = $(this).val()
        let otherHandledBy = $(this).closest('form').find('#otherHandledBy')

        if (handledBy && handledBy === 'Other') {
            $(otherHandledBy).removeClass('d-none')
        } else {
            $(otherHandledBy).addClass('d-none')
        }
    })
});